// Notify
import { Notify } from 'notiflix';
import { notifyOptions } from './../../Utils/notifyOptions';

export const showSuccessNotify = (text: string) => {
  Notify.success(text, notifyOptions);
};
